export default __webpack_public_path__ + "static/media/fi6.29891951.png";